/*
 * @providesModule StringUtils
 * 
 */

import SKZConstants from 'SKZConstants';

export default class StringUtils {

  static capitalizeFirstLetter(string: String): String {
    return string.charAt(0).toUpperCase() + string.substr(1);
  }

  // Solution from https://stackoverflow.com/questions/1199352/smart-way-to-truncate-long-strings
  static truncateString(string: string, length: number, useWordBoundary: boolean): string {
    if (string.length <= length) { 
      return string; 
    }
    const subString = string.substr(0, length - 1);
    return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString) + "...";
  }

  /**
   * Formats currency values with proper symbols and decimal handling
   * Drops .00 decimals for whole numbers
   * @param amount - The amount to format
   * @param currencyType - The currency type from SKZConstants.CurrencyTypes
   * @returns Formatted currency string
   */
  static formatCurrency(amount: number, currencyType: SKZConstants.CurrencyTypes): string {
    if (currencyType === SKZConstants.CurrencyTypes.CASH) {
      // For cash, show $ and format appropriately
      return amount % 1 === 0 ? `$${amount.toFixed(0)}` : `$${amount.toFixed(2)}`;
    } else {
      // For z, ticketz, and medal, just show the number
      return amount % 1 === 0 ? amount.toFixed(0) : amount.toString();
    }
  }
}
